import { Injectable } from '@angular/core';
import { createEffect, Actions } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { filter, mergeMap, catchError, map } from 'rxjs/operators';
import {
    GetUserPermissionsRequest,
    GetUserPermissionsRequestFailure,
    GetUserPermissionsRequestSuccess
} from './rbac.actions';

import { AddAPIErrorAlert } from '../../../alerts/store/alerts.action';
import { UserPermissionsService } from '../../../shared/services/user-permissions.service';
import { RbacUserPermissions } from '../../../../../common/models/rbac.interface';
import { ApiResponse } from '../../../../../common/models/api-response.interface';

@Injectable()
export class RbacEffects {
    rbacUserPermissions$ = createEffect(() =>
        this.actions$.pipe(
            filter((action: Action) => {
                return action instanceof GetUserPermissionsRequest;
            }),
            mergeMap(() =>
                this.rbacUserPermissions.getRbacUserPermissions().pipe(
                    map(
                        (response: ApiResponse<RbacUserPermissions>) =>
                            new GetUserPermissionsRequestSuccess(response.data)
                    ),
                    catchError((err) =>
                        of(
                            new AddAPIErrorAlert(err.error),
                            new GetUserPermissionsRequestFailure(err)
                        )
                    )
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private rbacUserPermissions: UserPermissionsService
    ) {}
}
